import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="border-b border-line bg-sand" data-id="element-58" data-mp="1bmdazj6wgyav">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-59" data-mp="1gitx67ujh2lb">
        <div className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-60" data-mp="1glgbqrfukid1">
          <div data-id="element-61" data-mp="249zkf82t6x5n">
            <Eyebrow data-id="element-62" data-mp="24bk6saeyz9sf">Preguntas frecuentes</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-63" data-mp="289q9968rz37j">
              Antes de decidir
            </h2>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-64" data-mp="1zi7umzrh8vgk">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <li key={faq.question} data-id="element-65" data-mp="2rysbor8hkgtx" data-mpi={index}>
                  <h3 data-id="element-66" data-mp="2rztw3mbe6fob">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-67" data-mp="2s03dwmma9gix">
                      <span className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-68" data-mp="1oj9jv0vtpq43">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-paper text-ink-soft" data-id="element-69" data-mp="1jjwzcmsfcv4o">
                        {isOpen ? <MinusIcon className="h-3.5 w-3.5" data-id="element-70" data-mp="36q2a1pf3aua" /> : <PlusIcon className="h-3.5 w-3.5" data-id="element-71" data-mp="3udaw1t6uwwv0" />}
                      </span>
                    </button>
                  </h3>
                  {isOpen && <div id={`faq-panel-${index}`} className="pb-6 pr-12" data-id="element-72" data-mp="23991vbthjiie">
                      <p className="max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-73" data-mp="286rd58uz69tk">
                        {faq.answer}
                      </p>
                    </div>}
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}